import { PropertyTypeEnum, RentalTypeEnum } from 'api/real-estate';
import { ComponentKey } from 'enums/componentKey';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';
import { InputsConfig } from 'types/form/inputsConfig';
import { RealEstateFormFieldNames } from '../types/realEstateFormFieldNames';

export const realEstateInputsConfig: InputsConfig<RealEstateFormFieldNames> = {
  [RealEstateFormFieldNames.Id]: {
    componentKey: ComponentKey.InputText,
    name: RealEstateFormFieldNames.Id,
    type: 'text',
    required: false,
    label: 'REAL_ESTATE.LABELS.ID',
    placeholder: 'REAL_ESTATE.PLACEHOLDERS.ID'
  },

  [RealEstateFormFieldNames.Name]: {
    componentKey: ComponentKey.InputText,
    name: RealEstateFormFieldNames.Name,
    type: 'text',
    required: true,
    label: 'REAL_ESTATE.LABELS.NAME',
    placeholder: 'REAL_ESTATE.PLACEHOLDERS.NAME'
  },

  [RealEstateFormFieldNames.Area]: {
    componentKey: ComponentKey.InputWithUnit,
    name: RealEstateFormFieldNames.Area,
    type: 'number',
    required: true,
    label: 'REAL_ESTATE.LABELS.AREA',
    placeholder: 'REAL_ESTATE.PLACEHOLDERS.AREA',
    unit: 'm²'
  },

  [RealEstateFormFieldNames.RoomCount]: {
    componentKey: ComponentKey.InputWithUnit,
    name: RealEstateFormFieldNames.RoomCount,
    type: 'number',
    required: true,
    label: 'REAL_ESTATE.LABELS.ROOM_COUNT',
    placeholder: 'REAL_ESTATE.PLACEHOLDERS.ROOM_COUNT',
    unit: 'pcs',
    min: 1,
    max: 20,
    step: 1
  },

  [RealEstateFormFieldNames.MonthlyRent]: {
    componentKey: ComponentKey.InputWithUnit,
    name: RealEstateFormFieldNames.MonthlyRent,
    type: 'number',
    required: false,
    label: 'REAL_ESTATE.LABELS.MONTHLY_RENT',
    placeholder: 'REAL_ESTATE.PLACEHOLDERS.MONTHLY_RENT',
    unit: '€'
  },

  [RealEstateFormFieldNames.Charges]: {
    componentKey: ComponentKey.InputWithUnit,
    name: RealEstateFormFieldNames.Charges,
    type: 'number',
    required: false,
    label: 'REAL_ESTATE.LABELS.CHARGES',
    placeholder: 'REAL_ESTATE.PLACEHOLDERS.CHARGES',
    unit: '€'
  },

  [RealEstateFormFieldNames.Photo]: {
    componentKey: ComponentKey.ImageUpload,
    name: RealEstateFormFieldNames.Photo,
    required: false,
    placeholder: 'REAL_ESTATE.LABELS.ADD_PHOTO',
    dragPlaceholder: 'COMMON.DRAG_DROP_OR_CLICK',
    height: 'h-64',
    maxSizeInMB: 5,
    acceptedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  },

  [RealEstateFormFieldNames.PropertyType]: {
    componentKey: ComponentKey.SelectCard,
    name: RealEstateFormFieldNames.PropertyType,
    required: true,
    label: 'REAL_ESTATE.LABELS.PROPERTY_TYPE',
    items: [
      { key: PropertyTypeEnum.Apartment, label: "Un appartement", icon: "building" },
      { key: PropertyTypeEnum.House, label: "Une maison", icon: "blueHouse" },
      { key: PropertyTypeEnum.Office, label: "Un garage", icon: "garage" },
      { key: PropertyTypeEnum.Commercial, label: "Un local commercial", icon: "garage" }
    ]
  },

  [RealEstateFormFieldNames.RentalType]: {
    componentKey: ComponentKey.SelectCard,
    name: RealEstateFormFieldNames.RentalType,
    required: true,
    label: 'REAL_ESTATE.LABELS.RENTAL_TYPE',
    items: [
      { key: RentalTypeEnum.NotForRent, label: "Pas de contrat en cours", icon: "magnifyingGlass" },
      { key: RentalTypeEnum.FurnishedLongTerm, label: "Location meublée (+9 mois)", icon: "furnished" },
      { key: RentalTypeEnum.UnfurnishedRental, label: "Location non-meublée", icon: "houseBlue" },
      { key: RentalTypeEnum.SeasonalRental, label: "Location saisonière", icon: "summerCalendar" },
      { key: RentalTypeEnum.StudentRental, label: "Location étudiante", icon: "student" },
    ]
  },

  [RealEstateFormFieldNames.SurveyForm]: {
    componentKey: ComponentKey.Custom,
    name: RealEstateFormFieldNames.SurveyForm
  },
  ...addressInputsConfig
};
